import {useBreakpointDown, useCurrentBreakpoint} from '@travel-frontend/core';
import {noop} from 'lodash';

import {ActiveFilters} from '@/components/ActiveFilters';
import {FilterDrawer} from '@/components/FilterDrawer';
import {FilterOverlay} from '@/components/FilterOverlay';
import {FilterChips} from '@/modules/common/components/FilterChips';
import {useFilterChips} from '@/modules/common/hooks/useFilterChips';
import {CallToActionButton} from '@/modules/hotels/components/Layout/components/FilterLayer/components/CallToActionButton';
import {useFilters} from '@/modules/hotels/hooks/useFilters';
import {useAppSelector} from '@/redux/config';
import {selectTranslations} from '@/redux/v1/hotels/list/reducer';

type Props = {
  isOpen: boolean;
  isLoading: boolean;
  children: React.ReactNode;
  onApply?: () => void;
  onReset?: () => void;
  onClose?: () => void;
};

export const FilterLayer: React.FunctionComponent<Props> = ({
  isOpen,
  isLoading,
  children,
  onApply = noop,
  onReset = noop,
  onClose = noop,
}) => {
  const currentBreakpoint = useCurrentBreakpoint();
  const smDown = useBreakpointDown('sm');
  const {filters} = useFilters();
  const translations = useAppSelector(selectTranslations); // @FIXME
  const filterChips = useFilterChips({filters, translations});

  const selectedFiltersElement = filterChips.length > 0 && (
    <ActiveFilters count={filterChips.length}>
      <FilterChips filterChips={filterChips} onClickReset={onReset} />
    </ActiveFilters>
  );

  if (currentBreakpoint === 'md') {
    return (
      <FilterDrawer
        open={isOpen}
        controls={<CallToActionButton loading={isLoading} onClick={onApply} />}
        selectedFilters={selectedFiltersElement}
        onClose={onClose}
      >
        {children}
      </FilterDrawer>
    );
  }

  if (smDown) {
    return (
      <FilterOverlay
        isOpen={isOpen}
        controls={<CallToActionButton loading={isLoading} onClick={onApply} />}
        selectedFilters={selectedFiltersElement}
        onClose={onClose}
      >
        {children}
      </FilterOverlay>
    );
  }

  return null;
};
